import {
  buildFollowUpPayload as buildLegacyFollowUpPayload,
  type BuildFollowUpPayloadInput,
} from '../../followUps/schema'
import { normalizeFollowUpChannel } from '../../followUps/channel'
import type {
  FollowUpPayload,
  FollowUpRow,
  FollowUpUpdatePayload,
} from '../types/database.types'
import { SchemaValidationError } from './strict'

export function buildFollowUpPayload(
  input: BuildFollowUpPayloadInput,
): FollowUpPayload {
  return buildLegacyFollowUpPayload(input)
}

export function buildFollowUpUpdatePayload(input: {
  scheduledAt: string
  channel: string
  reason?: string | null
}): FollowUpUpdatePayload {
  const date = new Date(input.scheduledAt)
  if (!input.scheduledAt || Number.isNaN(date.getTime())) {
    throw new SchemaValidationError('La fecha programada no es válida.')
  }

  const channel = normalizeFollowUpChannel(input.channel)
  if (!channel) {
    throw new SchemaValidationError(
      'Elegí un canal válido: WhatsApp, Instagram, Facebook, Correo o Teléfono.',
    )
  }

  return {
    scheduled_at: date.toISOString(),
    channel,
    reason:
      typeof input.reason === 'string' && input.reason.trim()
        ? input.reason.trim()
        : null,
  }
}

export function mapFollowUpRow(row: Record<string, unknown>): FollowUpRow {
  return row as FollowUpRow
}
